var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 147,
    viewBox: "0 0 196 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 147,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_471_16388",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 6,
    width: 135,
    height: 135
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 6H172V141H37V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_471_16388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.996 74.709C101.827 73.9273 99.9519 72.4955 98.6265 70.6089C97.3012 68.7223 96.5901 66.4729 96.5902 64.1673L96.5912 41.0945C96.433 24.7181 109.773 11.2731 126.121 11.2731H110.301C93.9532 11.2731 80.6135 24.7181 80.7709 41.0945L80.7693 79.8279L81.2461 79.3511C83.2747 77.3203 85.8901 75.9781 88.7228 75.5142C91.5555 75.0503 94.4624 75.488 97.0328 76.7656L103.996 74.709Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3574 109.37V37.6295C58.3574 27.7789 63.5077 19.192 71.3372 14.6686C70.9391 13.624 70.6044 12.5564 70.335 11.4715C70.3087 11.4056 70.2846 11.3388 70.2585 11.2737H68.6406C61.6478 11.2737 54.9413 14.0516 49.9965 18.9962C45.0517 23.9409 42.2736 30.6473 42.2734 37.6401V109.359C42.2734 112.822 42.9554 116.25 44.2805 119.449C45.6055 122.648 47.5477 125.555 49.9962 128.003C52.4446 130.452 55.3513 132.394 58.5503 133.719C61.7493 135.044 65.178 135.726 68.6406 135.726H81.4858C66.9651 135.726 58.3574 123.926 58.3574 109.37Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2227 11.2736H68.6406C65.178 11.2736 61.7493 11.9556 58.5503 13.2807C55.3513 14.6057 52.4446 16.5479 49.9961 18.9963C47.5477 21.4448 45.6055 24.3515 44.2805 27.5505C42.9554 30.7495 42.2734 34.1782 42.2734 37.6408V109.36C42.2734 112.822 42.9554 116.251 44.2805 119.45C45.6056 122.649 47.5478 125.556 49.9962 128.004C52.4446 130.453 55.3513 132.395 58.5504 133.72C61.7494 135.045 65.178 135.727 68.6406 135.727H105.291C108.754 135.727 112.182 135.045 115.381 133.72C118.58 132.395 121.487 130.453 123.935 128.004C126.384 125.556 128.326 122.649 129.651 119.45C130.976 116.251 131.658 112.822 131.658 109.36V100.659",
    stroke: "#006838",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.725 41.0946C166.775 37.1891 166.048 33.3126 164.585 29.691C163.123 26.0693 160.954 22.7749 158.206 19.9995C155.458 17.2241 152.185 15.0233 148.577 13.5251C144.97 12.027 141.101 11.2615 137.195 11.2733H110.301C93.9532 11.2733 80.6139 24.7182 80.7711 41.0946L80.7695 79.828L81.2463 79.3512C83.275 77.3203 85.8904 75.9781 88.7232 75.5141C91.556 75.0502 94.4629 75.4879 97.0334 76.7656C101.115 78.7923 105.612 79.8407 110.169 79.8278H137.064C153.319 79.8347 166.569 66.8423 166.725 50.5868V41.0946Z",
    stroke: "#006838",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.469 36.5859H105.027",
    stroke: "#F2C94C",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.648 55.043H105.027",
    stroke: "#F2C94C",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.953 111.996C93.953 113.744 93.2585 115.421 92.0223 116.657C90.7861 117.893 89.1095 118.588 87.3612 118.588C86.4956 118.588 85.6384 118.417 84.8386 118.086C84.0388 117.755 83.3122 117.269 82.7 116.657C82.0879 116.045 81.6024 115.318 81.2711 114.519C80.9398 113.719 80.7693 112.862 80.7693 111.996C80.7693 111.13 80.9398 110.273 81.2711 109.473C81.6024 108.674 82.0879 107.947 82.7 107.335C83.3122 106.723 84.0388 106.237 84.8386 105.906C85.6384 105.575 86.4956 105.404 87.3612 105.404C89.1095 105.404 90.7861 106.099 92.0223 107.335C93.2585 108.571 93.953 110.248 93.953 111.996Z",
    fill: "#F2C94C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecover);
export default __webpack_public_path__ + "static/media/recover.be613ed70c00672c0ff11f57a86caa4a.svg";
export { ForwardRef as ReactComponent };